<template>
	<div class="add_backimg">
		<div class="content minheight clearfix">
			<div class="left_types">
				<div class="left_search">
					<div class="left_searchTitle">在线课程</div>
					<div class="left_searchCont">
						<input type="text" v-model="name" @keyup.enter="currentChange(1)" placeholder="输入关键词后点击按钮搜索"/>
						<div class="left_searchIcon" @click="currentChange(1)">
							<i class="el-icon-search"></i>
						</div>
					</div>
				</div>
				<div class="left_filter clearfix">
					<div class="left_filterItem text-ellipsis" :class="item.id == typeId?'active':''" v-for="item in typeList" @click="typeChange(item.id)">
						{{item.name}}<span>（{{item.courseCount || 0}}）</span>
					</div>
				</div>
				<div class="left_foot">
					<span class="left_footText">ONLINE COURSES</span>
				</div>
			</div>
			<div class="right_list">
				<div class="right_title">
					<img src="@/images/titletext.png" />
					<div class="right_titleText" v-if="typeId == majorIdForAll">
						在线课程
					</div>
					<div class="right_titleText" v-if="typeId == item.id" v-for="item in typeList">
						{{item.name}}
					</div>
				</div>
				<div class="right_backlist" v-if="courses && courses.length>0">
					<img src="@/images/right_backitem.png" class="right_backitem" v-for="item in (parseInt(courses.length/4) +1)" />
				</div>
				<div class="right_itemlist clearfix">
					<emptymain :emptytext="'暂无课程'" :emptylist='courses'></emptymain>
					<div class="right_item" @click.stop="toCourseindex(item)" v-for="(item,index) in courses">
						<div class="right_coverItem">
							<div class="right_coverImg coverItem">
								<img :src="baseurl + item.banner" />
							</div>
							<div class="right_collect" @click.stop="moocCollection(item)">
								<div class="right_collectNormal">
									<img src="@/images/collected.png" v-if="item.isCollection" />
									<img src="@/images/collecting.png" v-if="!item.isCollection" />
									<span>{{item.collectionCount || 0}}</span>
								</div>
								<div class="right_collectHover">
									<span v-if="item.isCollection">取消收藏</span>
									<span v-if="!item.isCollection">点击收藏</span>
								</div>
							</div>
							<div class="right_play">
								<img src="@/images/normal.png" class="normal" />
								<img src="@/images/hovered.png" class="hovered" />
							</div>
						</div>
						<div class="right_infoTitle text-ellipsistwo">{{item.name}}</div>
						<div class="right_infoDesc text-ellipsistwo">{{item.info}}</div>
						<div class="right_infoStudy">{{item.signCount || 0}}人学习</div>
					</div>
					<div class="all_current">
						<el-pagination prev-text='上一页' next-text='下一页' background @current-change="currentChange" :page-size="limit" :current-page="current" layout="prev, pager, next" :total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getStorageToken } from '@/utils/auth'
	import { listMajorByPid } from '@/api/major'
	import { appCourseList } from '@/api/course'
	import { collectionSave, collectionDelete } from '@/api/collection'
	export default {
		data() {
			return {
				current: 1,
				limit: 1000,
				total: 0,
				typeId: this.majorIdForAll,
				name: '',
				typeList: [],
				courses: [],
			}
		},
		created() {
			this.getCourseTypes();
			this.getCourse();
		},
		mounted() {

		},
		methods: {
			nameChange(){
				if(!this.name){
					this.currentChange(1)
				}
			},
			currentChange(current) {
				this.current = current;
				this.getCourse();
			},
			typeChange(id) {
				if(this.typeId == id) {
					this.typeId = this.majorIdForAll
				} else {
					this.typeId = id;
				}
				this.current = 1;
				this.getCourse();
			},
			getCourseTypes() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(({
					data
				}) => {
					this.typeList = data;
				})
			},
			getCourse() {
				var data = {
					majorId: this.majorIdForAll,
					typeId: this.typeId == this.majorIdForAll ? null : this.typeId,
					name: this.name ? this.name : null,
					current: this.current,
					limit: this.limit,
				}
				appCourseList(data).then(res => {
					if(res.code == "OK") {
						this.courses = res.data.records;
						this.total = res.data.total;
					}
				})
			},
			moocCollection(item) {
				var token = getStorageToken();
				if(token) {
					if(!item.isCollection) {
						collectionSave({
							type: 'mooc',
							typeId: item.id
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: "收藏成功!",
								})
								this.getCourse();
							} else {
								this.$message({
									type: 'error',
									message: res.data.message,
								})
							}
						})
					} else {
						collectionDelete({
							type: 'mooc',
							typeId: item.id
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: '取消成功!'
								});
								this.getCourse();
							}
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})

				}
			},
			toCourseindex(item) {
				var token = getStorageToken();
				if(token) {
					this.$router.push({
						name: 'coursedetail',
						query: {
							courseId: item.id
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
		},
		beforeRouteLeave(to, from, next) {
			next();
		},
	}
</script>